import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useCollection } from '../../hooks/useFirestore';
import { PortfolioItem } from '../../types';
import { motion } from 'framer-motion';

const Portfolio: React.FC = () => {
  const { t } = useLanguage();
  const { data: allPortfolio, loading } = useCollection<PortfolioItem>('portfolio');
  const portfolio = allPortfolio.filter(p => p.status !== 'archived');

  return (
    <section id="portfolio" className="sw-section" role="region" aria-labelledby="portfolio-title">
      <div className="sw-container">
        <div className="section-header text-center">
          <span className="sw-eyebrow">{t('portfolio_eyebrow')}</span>
          <h2 id="portfolio-title">{t('portfolio_title')}</h2>
          <p className="section-desc">{t('services_desc')}</p>
        </div>
        <div className="portfolio-grid sw-grid">
          {loading ? (
            Array(3).fill(0).map((_, i) => (
              <div key={i} className="sw-card skeleton-card">
                <div className="sw-skeleton" style={{ height: '240px', borderRadius: '12px' }}></div>
              </div>
            ))
          ) : (
            portfolio.map((item, i) => (
              <motion.div
                key={item.id}
                className="sw-card portfolio-card group"
                style={{ padding: 0 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                whileHover={{ y: -4 }}
              >
                <div style={{ aspectRatio: '4/3', overflow: 'hidden' }}>
                  <img
                    src={item.thumbnail || '/src/assets/icons/1.jpg'}
                    alt={item.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    loading="lazy"
                  />
                </div>
                <div style={{ padding: 'var(--sp-4)' }}>
                  <span className="sw-eyebrow" style={{ marginBottom: 'var(--sp-1)', fontSize: '0.65rem' }}>{item.category}</span>
                  <h3 style={{ fontSize: '1.1rem' }}>{item.name}</h3>
                </div>
              </motion.div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
